export default __webpack_public_path__ + "static/media/hero-level-1-chars-mob.e1e1da5a.webp";